/**
 * The renderer's words for a list drawn as a board (list standard §12) and for a form that asks a
 * route what else a choice needs (`fields_from`). Kept beside the catalogue and spread into it, so a
 * parallel change to the catalogue does not collide with these.
 */
export const BOARD_EN = {
    'board.show.label': 'Show as',
    'board.show.table': 'Table',
    'board.show.board': 'Board',
    'board.scope.whole': 'Each lane counts every row the view leaves ({n}), not a page.',
    'board.scope.server': 'Each lane is counted by the server over every matching row; this page holds {n} of them.',
    'board.lanes.waiting': 'Reading the board’s lanes…',
    'board.lanes.unread': 'The board’s lanes could not be read, so it is not drawn. The table still shows every row.',
    'board.lane.empty': 'Nothing here',
    'board.lane.more': '{shown} of {count} here — the rest are on other pages',
    'board.lane.uncounted': 'not counted',
    'board.unplaced': '{n} rows are in none of these lanes; the table shows them.',
    'board.card.drag': 'Drag to another lane, or move it from ⋯',
    'board.move.moving': 'Moving…',
    'board.move.refused': '«{name}» was not moved: {reason}',
    'board.move.failed': 'the move could not be sent',
    'form.asked.loading': 'Asking what this choice needs…',
    'form.asked.failed': 'What this choice needs could not be read, so the form cannot be sent yet.',
    'form.asked.refused': 'The server asked for fields this form cannot draw: {detail}',
};
export const BOARD_AR = {
    'board.show.label': 'اعرض كـ',
    'board.show.table': 'جدول',
    'board.show.board': 'لوحة',
    'board.scope.whole': 'يعدّ كل عمود في اللوحة كل الصفوف التي يُبقيها العرض ({n})، لا صفحة منها.',
    'board.scope.server': 'يعدّ الخادم كل عمود في اللوحة على كل الصفوف المطابقة؛ في هذه الصفحة {n} منها.',
    'board.lanes.waiting': 'تُقرأ أعمدة اللوحة…',
    'board.lanes.unread': 'تعذّرت قراءة أعمدة اللوحة فلم تُرسم. الجدول ما زال يعرض كل الصفوف.',
    'board.lane.empty': 'لا شيء هنا',
    'board.lane.more': '{shown} من {count} هنا — الباقي في صفحات أخرى',
    'board.lane.uncounted': 'غير معدود',
    'board.unplaced': '{n} صفوف لا تقع في أي عمود من أعمدة اللوحة؛ يعرضها الجدول.',
    'board.card.drag': 'اسحبه إلى عمود آخر، أو انقله من ⋯',
    'board.move.moving': 'يُنقل…',
    'board.move.refused': 'لم يُنقل «{name}»: {reason}',
    'board.move.failed': 'تعذّر إرسال النقل',
    'form.asked.loading': 'يُسأل عمّا يتطلبه هذا الاختيار…',
    'form.asked.failed': 'تعذّرت قراءة ما يتطلبه هذا الاختيار، فلا يمكن إرسال النموذج بعد.',
    'form.asked.refused': 'طلب الخادم حقولًا لا يستطيع هذا النموذج رسمها: {detail}',
};
//# sourceMappingURL=i18n-board.js.map